$.fn.navigation = function (options) {
    'use strict';

    var _elem = $(this),  // instance to $('#selector')
        _this = this,     // instance to this plugin
        _toggleNav = $('.toggle-nav-mobile');

    // custom variables
    var o = $.extend({

    }, options);


    _this.init = function() {
        $('body').append('<div id="nav-overlay" class="overlay-hidden"></div>');

        _toggleNav.on('click', function() {
            _this.toggleNavMobile();
        });

        $(document).on('click', '#nav-overlay', function() {
            _this.toggleNavMobile();
        });

        _elem.find('.toggle-sub').on('click', function() {
            _this.toggleSubNav($(this));
        });
    };

    _this.toggleSubNav = function(elem) {
        var parentContainer = elem.parents('li');
        var subnav = parentContainer.find('ul.sub-navigation');

        if (!subnav.hasClass('sub-open'))
        {
            subnav.addClass('sub-open').slideDown(300);
            parentContainer.addClass('sub-open');
            return false;
        }
        else
        {
            subnav.removeClass('sub-open').slideUp(300);
            parentContainer.removeClass('sub-open');
            return false;
        }
    };

    _this.toggleNavMobile = function() {
        if (_elem.hasClass('mobile-hidden'))
        {
            _elem.removeClass('mobile-hidden').addClass('mobile-visible');
            _toggleNav.removeClass('nav-hidden').addClass('nav-visible');
            $('#nav-overlay').addClass('overlay-visible').removeClass('overlay-hidden');
            return false;
        }
        else
        {
            _elem.addClass('mobile-hidden').removeClass('mobile-visible');
            _toggleNav.addClass('nav-hidden').removeClass('nav-visible');
            $('#nav-overlay').addClass('overlay-hidden').removeClass('overlay-visible');
            return false;
        }
    };

    _this.init();
};